import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ButtonComponent, FormProviderComponent, SelectionComponent, TextFieldComponent } from "../../../../components/form";
import SnackbarComponent from '../../../../components/snackBar/snackbarComponent';

const CalculatorFilterMobileForm = ({
    moveNextStep,
    defaultData,
    buttonLoading,
    dropDownDataLoading,
    tourSitesAndActivities
}) => {
    const [sitesList, setSitesList] = useState([]);
    const [activitiesList, setActivitiesList] = useState([]);

    const [snackBar, setSnackBar] = useState({
        message: "",
        open: false,
        color: ""
    });
    
    const formSchema = yup.object().shape({
        sites: yup.array(),
        activities: yup.array(),
        kids: yup.number().typeError('Invalid number of kids count').test(
            'isValidKids', 
            'Invalid number of kids count',
            () => {
                return Number.parseFloat(values.kids) >= 0;
            }
        ),
        adults: yup.number().required('Adults count is required').typeError('Invalid number of adults count').moreThan(0, 'Adults count should be greater than 0')
    });
        
    const defaultValues = {
        sites: [],
        activities: [],
        kids: 0,
        adults: 0
    };
        
    const formMethods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: defaultValues
    });
        
    const {
        setValue,
        reset: reset,
        handleSubmit: handleSubmit,
        formState: { isSubmitting: isSubmitting },
        watch
    } = formMethods;
        
    const values = watch();

    useEffect(() => {
        if(!tourSitesAndActivities) return;

        console.log(tourSitesAndActivities);

        // Sites
        const siteValuesArray = Object.values(tourSitesAndActivities?.sites);
        const siteKeysArray = Object.keys(tourSitesAndActivities?.sites);

        const sList = [];
        for(let i = 0; i < siteKeysArray.length; i++){
            sList.push({label: siteValuesArray[i], value: siteKeysArray[i]});
        }

        setSitesList(sList);

        // Activities
        const activityValuesArray = Object.values(tourSitesAndActivities?.activities);
        const activityKeysArray = Object.keys(tourSitesAndActivities?.activities);

        const aList = [];
        for(let i = 0; i < activityKeysArray.length; i++){
            aList.push({label: activityValuesArray[i], value: activityKeysArray[i]});
        }

        setActivitiesList(aList);
    }, [tourSitesAndActivities]);

    useEffect(() => {
        setValue('adults', defaultData?.adults);
        setValue('kids', defaultData?.kids);
    }, [defaultData]);

    useEffect(() => {
        if(sitesList.length > 0){
            const selectedSitesList = [];
            for(let i = 0; i < defaultData?.sites?.length; i++){
                selectedSitesList.push(String(defaultData.sites[i]));
            }
            
            console.log(selectedSitesList);
            setValue('sites', selectedSitesList);
        }
    }, [defaultData, sitesList]);

    useEffect(() => {
        if(activitiesList.length > 0){
            const selectedActivitiesList = [];
            for(let i = 0; i < defaultData?.activities?.length; i++){
                selectedActivitiesList.push(String(defaultData.activities[i]));
            }
            setValue('activities', selectedActivitiesList);
        }
    }, [defaultData, activitiesList]);

    const onSubmit = handleSubmit(async(data) => {
        console.log(data);

        if(data.sites.length === 0 && data.activities.length === 0){
            setSnackBar({
                message: "Select at-least either one of site/activity",
                color: "red",
                open: true
            });

            return;
        }
        
        moveNextStep(data);
    });

    return (
        <>
            <Stack 
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{
                    pt: 2,
                    pb: 3
                }}
                spacing={2}
            >
                <Box sx={{width: '100%'}}>
                    <FormProviderComponent methods={formMethods} onSubmit={onSubmit}>
                        {/* Sites */}
                        {
                            dropDownDataLoading
                            ?
                            <Stack
                                direction='column'
                                width='100%'
                                mb={2}
                            >
                                <Typography
                                    fontWeight={400}
                                    fontSize={{xs: 16, lg: 25}}
                                    letterSpacing={0.3}
                                    pb={1}
                                >
                                    Sites
                                </Typography>

                                <Skeleton variant="rounded" width='100%' height={55} />
                            </Stack>
                            :
                            <>
                                {
                                    sitesList.length > 0
                                    ?
                                    <SelectionComponent 
                                        name="sites"
                                        label="Sites"
                                        list={sitesList}
                                        fullWidth
                                        multiple
                                        showListIcons
                                    />
                                    :
                                    <Box pb={2}>
                                        <Typography
                                            fontWeight={400}
                                            fontSize={14}
                                        >
                                            No sites available
                                        </Typography>
                                    </Box>
                                }
                            </>
                        }

                        {/* Activities */}
                        {
                            dropDownDataLoading
                            ?
                            <Stack
                                direction='column'
                                width='100%'
                                my={2}
                            >
                                <Typography
                                    fontWeight={400}
                                    fontSize={{xs: 16, lg: 25}}
                                    letterSpacing={0.3}
                                    pb={1}
                                >
                                    Activities
                                </Typography>

                                <Skeleton variant="rounded" width='100%' height={55} />
                            </Stack>
                            :
                            <>
                                {
                                    activitiesList.length > 0
                                    ?
                                    <SelectionComponent 
                                        name="activities"
                                        label="Activities"
                                        list={activitiesList}
                                        fullWidth
                                        multiple
                                        showListIcons
                                    />
                                    :
                                    <Box pb={2}>
                                        <Typography
                                            fontWeight={400}
                                            fontSize={14}
                                        >
                                            No activities available
                                        </Typography>
                                    </Box>
                                }
                            </>
                        }

                        {/* Kids */}
                        <TextFieldComponent 
                            name='kids'
                            label='# Kids (6-11.99)'
                            fullWidth
                        />

                        {/* Adults */}
                        <TextFieldComponent 
                            name='adults'
                            label='# Adults *'
                            fullWidth
                        />

                        <ButtonComponent 
                            label='Next'
                            fullWidth
                            type="submit"
                            inLoading={buttonLoading}
                            sx={{
                                mt: 3
                            }}
                        />
                    </FormProviderComponent>
                </Box>
            </Stack>

            <SnackbarComponent 
                message={snackBar.message}
                color={snackBar.color}
                open={snackBar.open}
                handleClose={() => setSnackBar({
                    message: "",
                    open: false
                })}
            />
        </>
    );
}

export default CalculatorFilterMobileForm;